var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_1222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02949 0 0 4.02949 0 9C0 13.9705 4.02949 18 9 18C13.9705 18 18 13.9705 18 9C18 4.02949 13.9705 0 9 0ZM5.25767 8.97488C5.13864 8.86397 4.98121 8.80359 4.81854 8.80646C4.65587 8.80933 4.50066 8.87523 4.38562 8.99027C4.27058 9.10531 4.20468 9.26052 4.20181 9.42319C4.19894 9.58586 4.25932 9.74329 4.37023 9.86232L6.88186 12.374C6.99959 12.4915 7.15919 12.5576 7.32558 12.5576C7.49198 12.5576 7.65157 12.4915 7.7693 12.374L13.6298 6.51349C13.7407 6.39446 13.8011 6.23702 13.7982 6.07435C13.7953 5.91168 13.7294 5.75648 13.6144 5.64143C13.4993 5.52639 13.3441 5.46049 13.1815 5.45762C13.0188 5.45475 12.8614 5.51513 12.7423 5.62605L7.32558 11.0428L5.25767 8.97488Z",
    fill: "#FE6F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_1222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCheck);
export default __webpack_public_path__ + "static/media/small_check.9d2da9452f39ca938e5e34955b9c7732.svg";
export { ForwardRef as ReactComponent };